export default __webpack_public_path__ + "static/media/Disposal.6956e4c9.svg";